import _ from 'lodash';

const checkIfInBoundFlightInputsChanged = ({ searchInputs, searchObject }) => {
  const searchInputSegments = _.get(searchInputs, 'flightSegments', []);
  const searchObjectSegments = _.get(searchObject, 'flightSegments', []);
  if (!Array.isArray(searchInputSegments) || !Array.isArray(searchObjectSegments)) return -1;
  if (searchInputSegments.length !== searchObjectSegments.length) return 0;

  for (let i = 0; i < searchInputSegments.length; i += 1) {
    if (
      !_.isEqual(
        {
          flightTime: searchInputSegments[i].flightTime,
          departureTimeWindow: searchInputSegments[i].departureTimeWindow,
          arrivalTimeWindow: searchInputSegments[i].arrivalTimeWindow,
          airlines: searchInputs.hasDifferentOutboundInboundAirLine
            ? searchInputSegments[i].airlines
            : searchInputSegments[0].airlines,
          alliances: searchInputs.hasDifferentOutboundInboundAlliance
            ? searchInputSegments[i].alliances
            : searchInputSegments[0].alliances,
          connectingAirports: searchInputSegments[i].connectingAirports,
          connectingAirportsPreference: searchInputSegments[i].connectingAirportsPreference,
          minLayoverDuration: searchInputSegments[i].minLayoverDuration,
          maxLayoverDuration: searchInputSegments[i].maxLayoverDuration,
          preferredCabin: searchInputSegments[i].preferredCabin,
        },
        {
          flightTime: searchObjectSegments[i].flightTime,
          departureTimeWindow: searchObjectSegments[i].departureTimeWindow,
          arrivalTimeWindow: searchObjectSegments[i].arrivalTimeWindow,
          airlines: searchInputs.hasDifferentOutboundInboundAirLine
            ? searchObjectSegments[i].airlines
            : searchObjectSegments[0].airlines,
          alliances: searchInputs.hasDifferentOutboundInboundAlliance
            ? searchObjectSegments[i].alliances
            : searchObjectSegments[0].alliances,
          connectingAirports: searchObjectSegments[i].connectingAirports,
          connectingAirportsPreference: searchObjectSegments[i].connectingAirportsPreference,
          minLayoverDuration: searchObjectSegments[i].minLayoverDuration,
          maxLayoverDuration: searchObjectSegments[i].maxLayoverDuration,
          preferredCabin: searchObjectSegments[i].preferredCabin,
        },
      )
    ) {
      return i;
    }
  }
  return -1;
};

export default checkIfInBoundFlightInputsChanged;
